export const DUPLICATE_NAME_PREFIX = "Copy of ";

export function buildDuplicateName({
    sourceName,
    maxLength,
}: {
    sourceName: string;
    maxLength: number;
}): string {
    const prefixed = `${DUPLICATE_NAME_PREFIX}${sourceName}`;
    if (prefixed.length <= maxLength) {
        return prefixed;
    }
    return prefixed.slice(0, maxLength).trimEnd();
}
